module.exports = __webpack_public_path__ + "img/podkrovni_pokoj_1.5c08bc70.jpg";